import axios from 'axios';

const RESOURCE_NAME = '/admin/users';

export default {

    getList(data) {
        return axios.post(`${RESOURCE_NAME}/get-list`, data)
    },

    getAdminToken(userId) {
        return axios.get(`${RESOURCE_NAME}/get-admin-token?id=${userId}`)
    }
}